import { createContext } from 'react'

import { type SupportedLocale } from './utils'

interface LocaleContextValue {
  locale: SupportedLocale
  setLocale: (locale: SupportedLocale) => void
}

export const LocaleContext = createContext<LocaleContextValue | null>(null)
